import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enResource from './locales/strings-en';
import jaResource from './locales/strings-ja';
import { supportedLocales } from './locales/supportedLocales';
import { isGovCloudRegion } from './utils';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: isGovCloudRegion
      ? {
          en: {
            translation: enResource,
          },
        }
      : {
          en: {
            translation: enResource,
          },
          ja: {
            translation: jaResource,
          },
        },
    lng: 'en',
    fallbackLng: 'en',
    nonExplicitWhitelist: true,
    whitelist: supportedLocales,

    debug: false,

    keySeparator: '.', // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
